import { render, staticRenderFns } from "./DashboardCampaign.vue?vue&type=template&id=620f8130&scoped=true&"
import script from "./DashboardCampaign.vue?vue&type=script&lang=js&"
export * from "./DashboardCampaign.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCampaign.vue?vue&type=style&index=0&id=620f8130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f8130",
  null
  
)

export default component.exports